export const blotName = {
  contain: 'contain',
  tableWrapper: 'tableWrapper',
  table: 'table',
  tableColGroup: 'colgroup',
  tableCol: 'col',
  tableBody: 'tbody',
  tableRow: 'tr',
  tableCell: 'td',
  tableCellInner: 'tableCellInner',
};
export const moduleName = {
  table: 'table',
};
export const toolName = {
  table: 'table',
};
